module.exports = __webpack_public_path__ + "img/ico_mypage_mobility.e8927adb.png";